
(() => {
  const scrollOwners = new Set();
  let savedOverflow = '';
  function lockScroll(owner) {
    if (scrollOwners.has(owner)) return;
    if (!scrollOwners.size) savedOverflow = document.documentElement.style.overflow;
    scrollOwners.add(owner); document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll(owner) {
    if (!scrollOwners.delete(owner)) return;
    if (!scrollOwners.size) document.documentElement.style.overflow = savedOverflow;
  }
  if (!customElements.get('robin-configurator')) customElements.define('robin-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.ready = true;
      this.validOptions = this.dataset.validOptions !== 'false';
      this.controller = new AbortController();
      const on = (el, event, fn) => el?.addEventListener(event, fn, {signal:this.controller.signal});
      this.variants = [...this.querySelectorAll('[data-variant-template]')];
      const initial = this.variants.find(v => v.dataset.variantTemplate === this.dataset.initial);
      if (!initial) return;
      this.side = initial.dataset.side; this.color = initial.dataset.color;
      this.selection = null; this.pending = null;
      this.dialog = this.querySelector('.rc-dialog');
      this.swatchLightbox = this.querySelector('.rc-swatch-lightbox');
      on(this, 'click', event => {
        if (this.busy()) return;
        const side = event.target.closest('button[data-side]');
        const color = event.target.closest('[data-popular-color]');
        if (side) { this.side = side.dataset.side; this.resetServerError(); this.render(); }

if (color) {
  this.color = color.dataset.popularColor;
  this.selection = null;
  this.pending = null;
  this.resetServerError();
  this.render();

  // Przewijanie do galerii tylko na telefonach
  if (window.matchMedia('(max-width: 767px)').matches) {
    requestAnimationFrame(() => {
      const gallery = [...document.querySelectorAll('robin-gallery')]
        .find(el => el.dataset.section === this.dataset.section);

      if (gallery) {
       window.scrollTo({
  top: 0,
  behavior: 'smooth'
});
      }
    });
  }
}
      });
      on(this.querySelector('[data-open]'), 'click', () => {
        if (this.busy()) return;
        this.pending = this.selection; this.preview();
        const priceHost = this.querySelector('[data-custom-price]');
        const customPrice = this.resolve(this.side, 'Inna tkanina')?.content.querySelector('[data-variant-price]');
        if (priceHost) priceHost.replaceChildren(...(customPrice ? [...customPrice.childNodes].map(node => node.cloneNode(true)) : []));
        const active = this.pending?.closest('[data-fabric-panel]')?.dataset.fabricPanel || '0';
        this.activateFabric(active);
        this.dialog.showModal(); this.lockScroll();
      });
      on(this.querySelector('[data-close]'), 'click', () => { this.swatchLightbox?.close(); this.dialog.close(); this.unlockScroll(); });
      this.querySelectorAll('[data-fabric-tab]').forEach(tab => on(tab, 'click', () => this.activateFabric(tab.dataset.fabricTab)));
      this.querySelectorAll('[data-swatch-zoom]').forEach(button => on(button, 'click', () => {
        const image = this.swatchLightbox?.querySelector('img');
        if (!image) return;
        image.src = button.dataset.swatchZoom;
        image.alt = button.dataset.swatchAlt;
        this.swatchLightbox.showModal();
      }));
      on(this.querySelector('[data-swatch-zoom-close]'), 'click', () => this.swatchLightbox?.close());
      on(this.dialog, 'close', () => { if (this.swatchLightbox?.open) this.swatchLightbox.close(); if (!this.dialog.open) this.unlockScroll(); this.dialog.querySelectorAll('video').forEach(v => v.pause()); });
      this.querySelectorAll('[data-swatch]').forEach(button => on(button, 'click', () => { this.pending = button; this.preview(); }));
      on(this.querySelector('[data-confirm]'), 'click', () => {
        const custom = this.resolve(this.side, 'Inna tkanina');
        if (this.busy() || !this.pending || !this.canCustomize(custom)) return;
        this.selection = this.pending; this.color = 'Inna tkanina'; this.resetServerError(); this.render(); this.dialog.close(); this.unlockScroll();
      });
      this.form.addEventListener('submit', event => {
        const variant = this.resolve();
        if (!this.validOptions || !variant || variant.dataset.available !== 'true' || (this.color === 'Inna tkanina' && !this.selection)) {
          event.preventDefault(); event.stopImmediatePropagation();
          const error = this.querySelector('[data-error]'); error.hidden = false;
          error.textContent = 'Wybierz dostępną stronę i kolor. Dla własnej tkaniny zatwierdź próbkę.';
        } else {
          this.form.querySelector('[name=id]').value = variant.dataset.variantTemplate;
        }
      }, {capture:true, signal:this.controller.signal});
      on(window, 'popstate', () => {
        const id = new URL(location.href).searchParams.get('variant') || this.dataset.initial;
        const v = this.variants.find(item => item.dataset.variantTemplate === id);
        if (v) { this.side = v.dataset.side; this.color = v.dataset.color; this.selection = null; this.render(false); }
      });
      this.render(false);
    }
    disconnectedCallback() { this.unlockScroll(); this.controller?.abort(); this.ready = false; }
    lockScroll() { lockScroll(this); }
    unlockScroll() { unlockScroll(this); }
    resetServerError() {
      const host = this.form.closest('product-form');
      if (host?.error) { host.error = false; this.form.querySelector('[name=add]')?.removeAttribute('aria-disabled'); }
      host?.handleErrorMessage?.();
    }
    busy() { return this.form.querySelector('[name=add]')?.classList.contains('loading'); }
    resolve(side = this.side, color = this.color) { return this.variants.find(v => v.dataset.side === side && v.dataset.color === color); }
    canCustomize(custom) {
      return !!custom && custom.dataset.available === 'true';
    }
    render(updateURL = true) {
      const variant = this.resolve();
      const custom = this.color === 'Inna tkanina';
      const available = variant?.dataset.available === 'true';
      const valid = this.validOptions && available && (!custom || !!this.selection);
      const id = variant?.dataset.variantTemplate || '';
      this.form.querySelector('[name=id]').value = id;
      this.form.querySelector('[name=id]').disabled = !variant;
      const installment = document.getElementById(`product-form-installment-${this.dataset.section}`)?.querySelector('[name=id]');
      if (installment) { installment.value = id; installment.dispatchEvent(new Event('change', {bubbles:true})); }
      const submit = this.form.querySelector('[name=add]');
      if (submit) {
        submit.disabled = !valid;
        const label = submit.querySelector('span');
        if (label) label.textContent = !variant ? 'Wybierz dostępny kolor' : !available ? 'Wyprzedane' : custom && !this.selection ? 'Wybierz tkaninę' : 'Dodaj do koszyka';
      }
      for (const [selector, value] of [['[data-property-fabric]',this.selection?.dataset.fabricName],['[data-property-color]',this.selection?.dataset.colorName]]) {
        const input = this.querySelector(selector); input.disabled = !custom || !this.selection; input.value = custom ? value || '' : '';
      }
      this.querySelectorAll('button[data-side]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.side === this.side)));
      this.querySelectorAll('[data-popular-color]').forEach(button => {
        const match = this.resolve(this.side, button.dataset.popularColor);
        button.disabled = !match || match.dataset.available !== 'true';
        button.setAttribute('aria-pressed', String(button.dataset.popularColor === this.color));
        button.querySelector('[data-color-status]').textContent = !match ? 'Brak tej kombinacji' : match.dataset.available !== 'true' ? 'Wyprzedane' : '';
        const image = button.querySelector('img');
        image.hidden = !match?.dataset.image;
        if (match?.dataset.image) { image.src = match.dataset.image; image.alt = match.dataset.title; } else image.removeAttribute('src');
      });
      const open = this.querySelector('[data-open]');
      if (open) { open.hidden = !this.canCustomize(this.resolve(this.side, 'Inna tkanina')); open.setAttribute('aria-pressed', String(custom)); }
      const summary = this.querySelector('[data-selection]');
      if (custom && this.selection) this.showSelection(summary, this.selection, this.side ? `${this.side} · ` : '');
      else { summary.replaceChildren(); const name = document.createElement('span'); name.textContent = [this.side, custom ? 'Wybierz tkaninę i kolor' : this.color].filter(Boolean).join(' · '); summary.append(name); }
      const error = this.querySelector('[data-error]'); error.hidden = !!variant;
      error.textContent = variant ? '' : 'Ten kolor nie występuje dla wybranej strony. Wybierz inny kolor.';
      const price = document.getElementById(`MainProduct-${this.dataset.section}`)?.querySelector('.price--product');
      const nextPrice = variant?.content.querySelector('.price--product');
      if (price && nextPrice) { price.replaceWith(nextPrice.cloneNode(true)); }
      else if (price) price.hidden = true;
      const gallery = [...document.querySelectorAll('robin-gallery')].find(el => el.dataset.section === this.dataset.section);
      if (gallery && this.galleryVariant !== id) {
        this.galleryVariant = id;
        gallery.querySelector('dialog')?.close();
        const contents = variant?.content.querySelector('[data-variant-gallery]');
        gallery.querySelector('.rc-gallery-content').replaceChildren(...(contents ? [...contents.childNodes].map(node => node.cloneNode(true)) : []));
        gallery.bindTrack?.();
      }
      const section = document.getElementById(`MainProduct-${this.dataset.section}`);
      const sku = section?.querySelector(`#Sku-${this.dataset.section}`);
      if (sku) { sku.textContent = variant?.dataset.sku || ''; sku.classList.toggle('visibility-hidden', !variant?.dataset.sku); }
      const inventory = section?.querySelector('.inventory__title--default');
      if (inventory) { inventory.textContent = available ? 'Dostępny' : 'Niedostępny'; inventory.classList.toggle('inventory__title--out_of_stock', !available); }
      const pickup = section?.querySelector('pickup-availability');
      if (pickup && this.pickupVariant !== id) {
        this.pickupVariant = id;
        if (available && pickup.fetchAvailability) pickup.fetchAvailability(id);
        else { pickup.removeAttribute('available'); pickup.innerHTML = ''; }
      }
      if (updateURL) {
        const url = new URL(location.href);
        if (id) url.searchParams.set('variant', id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
    }
    showSelection(target, selected, prefix = '') {
      target.replaceChildren();
      if (!selected) { target.textContent = 'Wybierz kolor tkaniny'; return; }
      const img = selected.querySelector('img'); if (img) target.append(img.cloneNode());
      if (target.matches('[data-preview]')) {
        const copy = document.createElement('span'); copy.className = 'rc-preview-copy';
        const label = document.createElement('small'); label.textContent = 'WYBRANA TKANINA';
        const name = document.createElement('strong'); name.textContent = `${selected.dataset.fabricName} · ${selected.dataset.colorName}`;
        copy.append(label, name); target.append(copy);
      } else {
        const name = document.createElement('span'); name.textContent = `${prefix}${selected.dataset.fabricName} · ${selected.dataset.colorName}`; target.append(name);
      }
    }
    activateFabric(index) {
      this.querySelectorAll('[data-fabric-tab]').forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.fabricTab === index)));
      this.querySelectorAll('[data-fabric-panel]').forEach(panel => {
        const active = panel.dataset.fabricPanel === index;
        panel.hidden = !active;
        if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      const scrollArea = this.querySelector('.rc-fabric-panes');
      if (scrollArea) scrollArea.scrollTop = 0;
    }
    preview() {
      this.querySelectorAll('[data-swatch]').forEach(el => el.setAttribute('aria-pressed', String(el === this.pending)));
      this.querySelector('[data-confirm]').disabled = !this.pending;
      this.showSelection(this.querySelector('[data-preview]'), this.pending);
    }
  });
  if (!customElements.get('robin-gallery')) customElements.define('robin-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.controller = new AbortController();
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) {
          const img = dialog.querySelector('img'); img.src = zoom.dataset.zoom; img.alt = zoom.querySelector('img').alt;
          dialog.showModal(); lockScroll(this); return;
        }
        if (event.target.closest('[data-close]')) { dialog.close(); this.unlockScroll(); return; }
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) this.go(this.index() + Number(arrow.dataset.galleryStep));
      }, {signal:this.controller.signal});
      this.addEventListener('keydown', event => {
        if (dialog.open || !event.target.closest('.rc-track')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index() + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, {signal:this.controller.signal});
      dialog.addEventListener('close', () => { if (!dialog.open) this.unlockScroll(); }, {signal:this.controller.signal});
      this.bindTrack();
    }
    index() { const track = this.querySelector('.rc-track'); return track?.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    go(index) {
      const track = this.querySelector('.rc-track'); if (!track) return;
      const next = Math.max(0, Math.min(index, track.children.length - 1));
      track.scrollTo({left: track.clientWidth * next, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    bindTrack() {
      this.trackController?.abort(); this.trackController = new AbortController();
      const track = this.querySelector('.rc-track');
      const update = () => {
        const count = track?.querySelectorAll('.rc-slide').length || 0;
        const index = this.index();
        const prev = this.querySelector('[data-gallery-step="-1"]');
        const next = this.querySelector('[data-gallery-step="1"]');
        if (prev) prev.hidden = index <= 0 || count <= 1;
        if (next) next.hidden = index >= count - 1 || count <= 1;
      };
      track?.addEventListener('scroll', update, {passive:true, signal:this.trackController.signal});
      window.addEventListener('resize', update, {passive:true, signal:this.trackController.signal});
      update();
    }
    unlockScroll() { unlockScroll(this); }
    disconnectedCallback() { this.unlockScroll(); this.controller?.abort(); this.trackController?.abort(); this.ready = false; }
  });
})();
